// FETCH ALL PART_DETAILS
export const FETCH_PART_DETAILS_REQUEST = 'FETCH_PART_DETAILS_REQUEST';
export const FETCH_PART_DETAILS_SUCCESS = 'FETCH_PART_DETAILS_SUCCESS';
export const FETCH_PART_DETAILS_FAILURE = 'FETCH_PART_DETAILS_FAILURE';
// FETCH ALL PART_DETAILS
export const FETCH_PART_DETAILS_BY_FABRIC_GROUP_REQUEST = 'FETCH_PART_DETAILS_BY_FABRIC_GROUP_REQUEST';
export const FETCH_PART_DETAILS_BY_FABRIC_GROUP_SUCCESS = 'FETCH_PART_DETAILS_BY_FABRIC_GROUP_SUCCESS';
export const FETCH_PART_DETAILS_BY_FABRIC_GROUP_FAILURE = 'FETCH_PART_DETAILS_BY_FABRIC_GROUP_FAILURE';

// CREATE PART_DETAILS
export const CREATE_PART_DETAILS_REQUEST = 'CREATE_PART_DETAILS_REQUEST';
export const CREATE_PART_DETAILS_SUCCESS = 'CREATE_PART_DETAILS_SUCCESS';
export const CREATE_PART_DETAILS_FAILURE = 'CREATE_PART_DETAILS_FAILURE';

// FETCH SINGLE PART DATA
export const FETCH_SINGLE_PART_DETAILS_REQUEST = 'FETCH_SINGLE_PART_DETAILS_REQUEST';
export const FETCH_SINGLE_PART_DETAILS_SUCCESS = 'FETCH_SINGLE_PART_DETAILS_SUCCESS';
export const FETCH_SINGLE_PART_DETAILS_FAILURE = 'FETCH_SINGLE_PART_DETAILS_FAILURE';

// UPDATE PART_DETAILS
export const UPDATE_PART_DETAILS_REQUEST = 'UPDATE_PART_DETAILS_REQUEST';
export const UPDATE_PART_DETAILS_SUCCESS = 'UPDATE_PART_DETAILS_SUCCESS';
export const UPDATE_PART_DETAILS_FAILURE = 'UPDATE_PART_DETAILS_FAILURE';

// DELETE PART_DETAILS
export const DELETE_PART_DETAILS_REQUEST = 'DELETE_PART_DETAILS_REQUEST';
export const DELETE_PART_DETAILS_SUCCESS = 'DELETE_PART_DETAILS_SUCCESS';
export const DELETE_PART_DETAILS_FAILURE = 'DELETE_PART_DETAILS_FAILURE';

// FETCH ALL PART_DETAILS BY STYLE DETAIL ID
export const FETCH_PART_DETAILS_BY_STYLE_DETAIL_ID_REQUEST = 'FETCH_PART_DETAILS_BY_STYLE_DETAIL_ID_REQUEST';
export const FETCH_PART_DETAILS_BY_STYLE_DETAIL_ID_SUCCESS = 'FETCH_PART_DETAILS_BY_STYLE_DETAIL_ID_SUCCESS';
export const FETCH_PART_DETAILS_BY_STYLE_DETAIL_ID_FAILURE = 'FETCH_PART_DETAILS_BY_STYLE_DETAIL_ID_FAILURE';

export const FETCH_FABRIC_ID_BASED_ON_FABRIC_GROUP_AND_FABRIC_TYPE_REQUEST =
    'FETCH_FABRIC_ID_BASED_ON_FABRIC_GROUP_AND_FABRIC_TYPE_REQUEST';
export const FETCH_FABRIC_ID_BASED_ON_FABRIC_GROUP_AND_FABRIC_TYPE_SUCCESS =
    'FETCH_FABRIC_ID_BASED_ON_FABRIC_GROUP_AND_FABRIC_TYPE_SUCCESS';
export const FETCH_FABRIC_ID_BASED_ON_FABRIC_GROUP_AND_FABRIC_TYPE_FAILURE =
    'FETCH_FABRIC_ID_BASED_ON_FABRIC_GROUP_AND_FABRIC_TYPE_FAILURE';

export const FETCH_YARN_ID_BASED_ON_YARN_GROUP_AND_YARN_TYPE_REQUEST = 'FETCH_YARN_ID_BASED_ON_YARN_GROUP_AND_YARN_TYPE_REQUEST';
export const FETCH_YARN_ID_BASED_ON_YARN_GROUP_AND_YARN_TYPE_SUCCESS = 'FETCH_YARN_ID_BASED_ON_YARN_GROUP_AND_YARN_TYPE_SUCCESS';
export const FETCH_YARN_ID_BASED_ON_YARN_GROUP_AND_YARN_TYPE_FAILURE = 'FETCH_YARN_ID_BASED_ON_YARN_GROUP_AND_YARN_TYPE_FAILURE';

export const FETCH_PART_ID_BASED_ON_PART_NAME_ID_REQUEST = 'FETCH_PART_ID_BASED_ON_PART_NAME_ID_REQUEST';
export const FETCH_PART_ID_BASED_ON_PART_NAME_ID_SUCCESS = 'FETCH_PART_ID_BASED_ON_PART_NAME_ID_SUCCESS';
export const FETCH_PART_ID_BASED_ON_PART_NAME_ID_FAILURE = 'FETCH_PART_ID_BASED_ON_PART_NAME_ID_FAILURE';

export const RESET_PART_DETAILS_INFO = 'RESET_PART_DETAILS_INFO';
export const IS_EDIT = 'IS_EDIT';
export const RESET_EDIT = 'RESET_EDIT';

export const RESET_PART_DETAILS_STATUS = 'RESET_PART_DETAILS_STATUS';

export const CREATE_PART_DETAILS_FORM = 'CREATE_PART_DETAILS_FORM';

export const UPDATE_PART_DETAILS_FORM = 'UPDATE_PART_DETAILS_FORM';

export const SCREEN_KNOWS_PCS = 'SCREEN_KNOWS_PCS'

export const RESET_PART_DETAILS_FABRIC_GROUP = 'RESET_PART_DETAILS_FABRIC_GROUP';


